import { useCallback, useMemo, useState } from 'react';

const useBooleanWidthAction = (initial) => {
  const [value, setValue] = useState(initial);
  const toggle = useCallback(() => setValue((v) => !v), []);
  const setTrue = useCallback(() => setValue(true), []);
  const setFalse = useCallback(() => setValue(false), []);
  const actions = useMemo(() => ({ setValue, toggle, setTrue, setFalse }), [
    setFalse,
    setTrue,
    toggle,
  ]);
  return useMemo(() => [value, actions], [actions, value]);
};

const useBoolean = (initial) => {
  const [value, actions] = useBooleanWidthAction(initial);
  return useMemo(
    () => ({
      value,
      ...actions,
    }),
    [actions, value],
  );
};

export default useBoolean;
